import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { Modal, Button, Spinner } from 'react-bootstrap';
import PaygroupForm from '../components/forms/PaygroupForm';
import '../styles/EmployeeMaster.css';
import PaygroupTable from '../components/PaygroupTable';

const PaygroupEditModel = () => {
    const baseUrl = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams(); // ✅ Get ID from route

  const [paygroupData, setPaygroupData] = useState(null);
  const [loading, setLoading] = useState(false);

  // ✅ Show modal only if URL starts with /sbu/edit
  const showModal = location.pathname.startsWith('/paygroup/edit');

  const handleCloseModal = () => {
    navigate('/paygroup'); // Go back to list
  };

  // ✅ Fetch SBU details by ID
  useEffect(() => {
    if (id && showModal) {
      setLoading(true);
      fetch(`${baseUrl}/getUserPayGroupById/${id}`)
        .then(res => res.json())
        .then(data => {
          if (data.status) {
            setPaygroupData(data.data);
          } else {
            setPaygroupData(null);
          }
          setLoading(false);
        })
        .catch(err => {
          console.error('Error fetching SBU by ID:', err);
          setLoading(false);
        });
    }
  }, [id, showModal]);

  return (
    <div className="employee-master-page">
      <div className="employee-header">
        <h2>Paygroup Master</h2>
      </div>

      {/* Table of SBUs */}
      <PaygroupTable />

      {/* Edit Modal */}
      <Modal show={showModal} onHide={handleCloseModal} size="md" centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Paygroup</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loading ? (
            <div className="text-center">
              <Spinner animation="border" /> Loading...
            </div>
          ) : paygroupData ? (
            <PaygroupForm paygroupId={id} initialData={paygroupData} /> // ✅ Pass data to form
          ) : (
            <p className="text-center">No data found for this SBU.</p>
          )}
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          <Button variant="primary">
            Save
          </Button>
        </Modal.Footer> */}
      </Modal>
    </div>
  );
};

export default PaygroupEditModel;
